
import * as easy from "@/components/easy";
import { catchError } from '@/utils/utils'
import { getSelfAccountInfo } from '@/api/acount-info-api'

// 租户上下文
const tenantContext = easy.getTenantContext();


const emptyAccountInfo = {
	oldAccount: false,
	tenantId: '',
	tenantName: '',
	employeeId: 0,
	//编号
	employeeNo: '',
	//昵称
	nickname: '',
	// 姓名
	name: '',
	mobileFuzzy: '',
	emptyPwd: false,
	//员工权限 0:无权限 1:可以访问 2: 可以操作
	permission: -1,
	oauthBindList:[]
};

const {data: currentAccountInfo, load: reloadAccountInfo } = easy.computedAsyncEx(async () => {
	if(!tenantContext.tenantId || !tenantContext.userId) {
		return emptyAccountInfo;
	}

	const { response, error } = await catchError(getSelfAccountInfo())
	if(error) {
		throw new easy.IgnoreError();
	}
	
	if(response?.code) {

		//兼容茶里退出情况
		if(response?.code != 200012){
			throw new easy.TipError(response.message);
		}
	}

	return response!.data;
}, emptyAccountInfo, { lazy: false, globalScope: true });


export {
	currentAccountInfo,
	reloadAccountInfo
}